import { render } from "./faqs-groups-list.vue?vue&type=template&id=3012b476"
import script from "./faqs-groups-list.vue?vue&type=script&lang=js"
export * from "./faqs-groups-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__